import { BaseContainerModel } from '../../base-container.model';
import {bl_fm_label_ext_RowClass, bl_fm_label_hdr_RowClass} from '../../../dbschema';

export class FileLabelContainerModel extends BaseContainerModel {
  bl_fm_label_hdr: bl_fm_label_hdr_RowClass = new bl_fm_label_hdr_RowClass();
  bl_fm_label_exts: bl_fm_label_ext_RowClass[] = [];
}
